angular.module("app").directive("colorFashionPieChart", function () {
  function link(scope) {
    scope.$watch("data", (newValue) => {
      if (newValue.length !== 0) {
        bindData();
      }
    });

    function bindData() {
      const element = document.getElementById(`my_fashion_color_${scope.mode}_dataviz`);
      if (element) {
        element.innerHTML = "";
      }

      let width = 250;
      let height = 250;
      const margin = 0;

      if (scope.type === 'fashion-designer-season') {
        width = 180;
        height = 180;
      }

      // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
      const radius = Math.min(width, height) / 2 - margin;

      const svg = d3
        .select(`#my_fashion_color_${scope.mode}_dataviz`)
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .append("g")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

      // Create chart data
      const percentageData = {};
      const colorData = {};
      for (const item of scope.data.colors) {
        colorData[item.name] = item.color;
        if(typeof(item.percentage) == "string" && item.percentage.indexOf('%') > -1) {
          percentageData[item.name] = item.percentage.replace('%','');
        } else {
          percentageData[item.name] = item.percentage;
        }
      }

      // Compute the position of each group on the pie:
      const pie = d3.layout
        .pie()
        .sort(null) // Do not sort group by size
        .value(function (d) {
          return d.value;
        });
      const data_ready = pie(d3.entries(percentageData));

      const data2 = {
        "color": 100,
      };

      const data_ready2 = pie(d3.entries(data2));

      // The arc generator
      const arc = d3.svg
        .arc()
        .innerRadius(radius * 0.85) // This is the size of the donut hole
        .outerRadius(radius * 0.95);

        const arc2 = d3.svg
        .arc()
        .innerRadius(radius * 0.85)
        .outerRadius(radius * 0.95);

      // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
      if(data_ready.length > 0) {
        svg
          .selectAll("allSlices")
          .data(data_ready)
          .enter()
          .append("path")
          .attr("d", arc)
          .attr("fill", function (d) {
            return colorData[d.data.key].hex;
          })
          .attr(
            "stroke", function (d) {
              return colorData[d.data.key].hex === "#ffffff"
                ? "#E0E0DD"
                : colorData[d.data.key].hex;
            }
          )
          .style(
            "stroke-width",  function (d) {
              return colorData[d.data.key].hex === "#ffffff"
                ? "1px"
                : "0px"
            }
          );
      } else {
        svg
        .selectAll("allSlices")
        .data(data_ready2)
        .enter()
        .append("path")
        .attr("d", arc2)
        .attr("stroke", "#E0E0DD")
        .style("stroke-width", "1px")
        .attr("fill", "none");
      }

      if (scope.data.image_url) {
        svg
          .append("text")
          .text(scope.data.name)
          .attr("transform", "translate(0, 35)")
          .attr("font-size", "18px")
          .attr("text-anchor", "middle")
          .attr("style", "font-family: Gotham SSm A, Gotham SSm B; text-transform: uppercase;");

        svg
          .append("image")
          .attr("href", scope.data.image_url)
          .attr("width", 60)
          .attr("height", 60)
          .attr("transform", "translate(-30, -50)");
      }
      else {
        svg
          .append("text")
          .text(scope.data.name)
          .attr("transform", "translate(0, 8)")
          .attr("font-size", "18px")
          .attr("text-anchor", "middle")
          .attr("style", "font-family: Gotham SSm A, Gotham SSm B; text-transform: uppercase;");
      }



    }

    const pagePerCount = 4;
    scope.currentPage = 0;

    scope.$watch("currentPage", (pageNumber) => {
      scope.colorSelections =
        scope.data.colors.slice(pagePerCount * pageNumber, pagePerCount * (pageNumber + 1));
    });


    scope.nextColors = () => {
      if (scope.data.colors.length / pagePerCount > scope.currentPage + 1) {
        scope.currentPage += 1;
      }
      else {
        scope.currentPage = 0;
      }
    }
  }
  return {
    restrict: "E",
    templateUrl: "app/directives/colorFashionPieChart/colorFashionPieChartView.html",
    link: link,
    scope: {
      data: "=",
      mode: "=",
      type: "=",
    },
  };
});
